module.exports = "<a ng-if=\"purchase.status === 'UNAUTHORIZED'\" class=\"btn btn-default btn-xs\" ng-click=authorize()><span class=\"glyphicon glyphicon-remove-circle\" aria-hidden=true></span>&nbsp;<span class=\"hidden-xs ng-scope\" translate=CANCEL>Cancel</span></a>";


//////////////////
// WEBPACK FOOTER
// ./js/actions/cancelpurchase.html
// module id = 434
// module chunks = 0